import React from 'react';
export interface BarDatum {
  label: string;
  value: number;
  /** Optional secondary value drawn as a lighter bar behind the main one. */
  comparison?: number;
}
interface BarChartProps {
  data: BarDatum[];
  format?: (value: number) => string;
  height?: number;
  /** Highlights the last bar — useful for "this month". */
  highlightLast?: boolean;
}

/**
 * Small hand-drawn bar chart. Deliberately minimal: no gridlines, no legend,
 * one accent colour. Values are read from the labels underneath, not from a
 * y-axis, which keeps it legible at dashboard size.
 */
export function BarChart({
  data,
  format = value => value.toLocaleString('da-DK'),
  height = 160,
  highlightLast = true
}: BarChartProps) {
  const max = Math.max(...data.map(d => Math.max(d.value, d.comparison ?? 0)), 1);
  return <div data-id="element-77" data-mp="2r07lgikqam3b">
      <div className="flex items-end gap-1.5 sm:gap-2" style={{
      height
    }} role="img" aria-label={data.map(d => `${d.label}: ${format(d.value)}`).join('. ')} data-id="element-78" data-mp="2r0h23fjvvgwc">
        {data.map((datum, index) => {
        const isLast = highlightLast && index === data.length - 1;
        return <div key={datum.label} className="group relative flex h-full flex-1 flex-col justify-end" data-id="element-79" data-mp="1jxfxyvoim48c" data-mpi={index}>
              <span className="pointer-events-none absolute -top-1 left-1/2 z-10 -translate-x-1/2 whitespace-nowrap rounded bg-stone-900 px-1.5 py-0.5 text-[10px] font-medium text-white opacity-0 transition-opacity group-hover:opacity-100" data-id="element-80" data-mp="1f5xwm6iky1mu">
                {format(datum.value)}
              </span>
              <div className={`w-full rounded-t transition-colors ${isLast ? 'bg-brand-600' : 'bg-brand-200 group-hover:bg-brand-400'}`} style={{
            height: `${Math.max(datum.value / max * 100, 2)}%`
          }} data-id="element-81" data-mp="22uzbabi0a90k" />
            </div>;
      })}
      </div>

      <div className="mt-2 flex gap-1.5 sm:gap-2" data-id="element-82" data-mp="23n0ghlgzwd1h">
        {data.map(datum => <span key={datum.label} className="flex-1 truncate text-center text-[10px] font-medium uppercase tracking-wide text-stone-400" data-id="element-83" data-mp="28lborrrn6fhl">
            {datum.label}
          </span>)}
      </div>
    </div>;
}